import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, TextField, Button, useMediaQuery, useTheme
} from '@mui/material';
import { Note } from '@mui/icons-material';
import { formatTimeDisplay } from '../../utils/formatTime';
import { formatPay, formatHours } from '../../utils/formatUtils';

export default function ManagerNotesDialog({
  open, onClose, onSave,
  editingEntry, managerNotesInput, setManagerNotesInput,
  savingNotes, timeFormat
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Note sx={{ mr: 1 }} />
        Edit Manager Notes
      </DialogTitle>
      <DialogContent>
        {editingEntry && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="textSecondary">
              Entry: {new Date(editingEntry.entry_date).toLocaleDateString()} - {formatTimeDisplay(editingEntry.start_time, timeFormat)} to {formatTimeDisplay(editingEntry.end_time, timeFormat)}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Hours: {formatHours(editingEntry.hours_worked)} | Pay: {formatPay(editingEntry.total_pay)}
            </Typography>
            {editingEntry.notes && (
              <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                Employee Notes: {editingEntry.notes}
              </Typography>
            )}
          </Box>
        )}
        <TextField
          fullWidth
          multiline
          rows={isMobile ? 6 : 4}
          label="Manager Notes"
          value={managerNotesInput}
          onChange={(e) => setManagerNotesInput(e.target.value)}
          placeholder="Add notes for this time entry..."
          sx={{ mt: 2 }}
          size={isMobile ? 'small' : 'medium'}
        />
      </DialogContent>
      <DialogActions sx={{ p: isMobile ? 2 : 1 }}>
        <Button onClick={onClose} disabled={savingNotes}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          color="primary"
          disabled={savingNotes}
        >
          {savingNotes ? 'Saving...' : 'Save Notes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
